import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 26 26",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M10.112 7.866a.32.32 0 0 1 .32.321v.32h5.134v-.32a.32.32 0 1 1 .642 0v.32h.642a1.283 1.283 0 0 1 1.283 1.284v7.058a1.283 1.283 0 0 1-1.284 1.284h-7.7a1.283 1.283 0 0 1-1.283-1.284V9.791A1.283 1.283 0 0 1 9.15 8.508h.641v-.321a.32.32 0 0 1 .321-.32ZM9.15 9.15a.642.642 0 0 0-.642.641v7.058a.642.642 0 0 0 .642.642h7.7a.642.642 0 0 0 .641-.642V9.791a.642.642 0 0 0-.642-.641h-7.7Z",
      fill: "#CDD3E2"
    }, null, -1),
    _createElementVNode("path", {
      d: "M9.47 10.433a.32.32 0 0 1 .322-.32h6.416a.32.32 0 0 1 .321.32v.642a.321.321 0 0 1-.32.32H9.791a.321.321 0 0 1-.321-.32v-.642Z",
      fill: "#CDD3E2"
    }, null, -1),
    _createElementVNode("path", {
      d: "m11.074 14.604 1.444 1.604L14.924 13",
      stroke: "#CDD3E2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "13",
      cy: "13",
      r: "12",
      stroke: "#CDD3E2",
      "stroke-width": "2",
      "stroke-dasharray": "5 5"
    }, null, -1)
  ]))]))
}
export default { render: render }